<div ngClass="{{messageClass}}" class="alert">
<h3 class="text-white">{{message}}</h3>
</div>
